export const focusInput = (root: HTMLDivElement, index: number) => {
  const [box] = root.children
  if (!box) {
    return
  }
  if (index < 0) {
    return
  }
  const inputParent = box.children.item(index)
  if (!inputParent) {
    return
  }
  inputParent.querySelector('input')?.focus()
}
